import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { MAIN_CONTENT_DATA_WRAPPER_SETTINGS } from '../../globals';
import TitleTop from '../../common/TitleTop/TitleTop';
import TextWrapper from '../../common/TextWrapper/TextWrapper';
import DataWrapper from '../../common/DataWrapper/DataWrapper';
import BtnOffice from '../../common/BtnOffice/BtnOffice';
import ErrorScreen from '../../common/ErrorScreen/ErrorScreen';
import { StyledBlockWrapper } from '../../common/DataWrapper/styles/StyledBlockWrapper';

import { StyledOfficesContent } from './styles/StyledOfficesContent';


class OfficesContent extends Component {
  constructor(props) {
    super(props);

    this.renderOffices = this.renderOffices.bind(this);
    this.renderOffice = this.renderOffice.bind(this);
  }

  renderOffices() {
    const { officesData } = this.props;
    const length = officesData.data.length;

    let ret = [];

    for (var i = 1; i < length; i = i + 2) {
      ret.push(
        <div className="row office-content-row row-equal"
          key={i}
        >
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderOffice(i - 1)}
          </div>
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderOffice(i)}
          </div>
        </div>
      );
    }

    if (length % 2 === 1) {
      ret.push(
        <div className="row office-content-row"
          key={length - 1}
        >
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderOffice(length - 1)}
          </div>
        </div>
      );
    }

    return ret;
  }

  renderOffice(id) {
    const { officesData, handleOnMouseMoveBtnOffice, } = this.props;
    return (
      <BtnOffice 
        id={officesData.data[id].id}
        title={officesData.data[id].pub_server_name}
        text={officesData.data[id].server_address}
        handleOnMouseMoveBtnOffice={handleOnMouseMoveBtnOffice}
        position={{
          lat: officesData.data[id].lat,
          lng: officesData.data[id].lon,  
        }}
      />
    );
  }

  render() {
    const { officesCommon, } = this.props;
    const { data, isLoading, status, } = this.props.officesData;

    const offices = 
      data.length < 1 ? 
        (
          <StyledBlockWrapper
            setMinHeight={true}
            minHeight={200}
          >
            <ErrorScreen 
              title="Nejsou dostupné žádné pobočky!"
            />
          </StyledBlockWrapper>
        ) : (
          this.renderOffices()
        );

    return (
      <StyledOfficesContent>

        <TitleTop   
          number={1}
          title={officesCommon.title}
        />

        <TextWrapper>
          <div dangerouslySetInnerHTML={{ __html: officesCommon.content }}></div>
        </TextWrapper>
          
        <DataWrapper
          isLoading={isLoading}
          status={status}
          minHeight={250}
          isLoadingText="Načítám"
          errorMessage="Nepodařilo se načíst data. Zkuste prosím stránku načíst znovu, nebo opakujte akci později."
          spinnerFat={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.spinnerFat} 
          spinnerSize={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.spinnerSize} 
          textSizeLoading={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.textSizeLoading}
          textSizeError={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.textSizeError}
        >

          { offices }
          
        </DataWrapper>

      </StyledOfficesContent>      
     
    );
  }
}


OfficesContent.propTypes = {
  handleOnMouseMoveBtnOffice: PropTypes.func.isRequired,
  officesData: PropTypes.object.isRequired,
};


export default OfficesContent;